import React, { useState } from "react";
import { Dayjs } from "dayjs";
import { Button, DatePicker, Form, message, Modal, Tooltip } from "antd";
import { FilterDates } from "../../redux/interfaces/folder.types.ts";
import {
  clearFilterDates,
  setFilterChoice,
  setFilterDates,
} from "../../redux/slices/folderSlice.ts";
import {
  CalendarOutlined,
  CloseOutlined,
  FilterOutlined,
} from "@ant-design/icons";
import "dayjs/locale/es";
import { useAppDispatch } from "../../redux/hooks.ts";

const { RangePicker } = DatePicker;

export const DateFilter: React.FC = () => {
  const [dateRange, setDateRange] = useState<[Dayjs, Dayjs] | null>(null);
  const dispatch = useAppDispatch();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const onOpenModal = () => {
    setIsOpen(true);
  };

  const onCloseModal = () => {
    setIsOpen(false);
  };

  const onSubmitDates = (values: any) => {
    if (!values.dates) {
      messageApi.error(
        "Debes seleccionar una fecha de inicio y una fecha de término",
      );
      return;
    }

    const dates: FilterDates = {
      startDate: values.dates[0].toDate().toISOString(),
      endDate: values.dates[1].toDate().toISOString(),
    };

    setDateRange(values.dates);

    if (dates.startDate && dates.endDate) {
      dispatch(setFilterChoice("range"));
      dispatch(setFilterDates(dates));
      setIsOpen(false);

      messageApi.success("Expedientes filtrados");
    }
  };

  const onClearDates = () => {
    setDateRange(null);
    form.resetFields();
    dispatch(clearFilterDates());
    dispatch(setFilterChoice("reset"));
  };

  return (
    <div className="w-full">
      {contextHolder}
      <div>
        <Modal
          title={
            <span>
              <CalendarOutlined /> Filtrado por rango de fechas
            </span>
          }
          open={isOpen}
          onCancel={onCloseModal}
          onOk={() => form.submit()}
          okText="Filtrar"
          cancelText="Cancelar"
          okButtonProps={{
            icon: <FilterOutlined />,
          }}
        >
          <div className="mb-2">
            Selecciona una fecha de inicio y de término para filtrar los
            expedientes:
          </div>
          <Form onFinish={onSubmitDates} form={form}>
            <Form.Item name="dates" style={{ marginTop: "10px" }}>
              <RangePicker />
            </Form.Item>
          </Form>
        </Modal>
      </div>
      <div style={{ fontSize: "0.925rem" }}>
        <div className="flex items-center bg-white text-gray-700">
          <Button
            type="default"
            className=""
            icon={<CalendarOutlined />}
            onClick={onOpenModal}
          >
            <div onClick={onOpenModal}>
              {dateRange
                ? `${dateRange[0].format("DD MMM YYYY")} - ${dateRange[1].format("DD MMM YYYY")}`
                : "Selecciona un rango de fechas"}
            </div>
            {dateRange && (
              <Tooltip title="Quitar filtro">
                <div className="ml-auto cursor-pointer" onClick={onClearDates}>
                  <CloseOutlined className="text-xs" />
                </div>
              </Tooltip>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};
